export default __webpack_public_path__ + "static/media/image-cushion-r-w.923cf4c0.png";